import { CSSProperties, type PropsWithChildren, } from "react";
import "./Chip.scss";



export declare type ChipProps = PropsWithChildren<{

	/** color scheme for this chip, default: "primary" */
	color?: "primary" | "success" | "brand";

	/** make the chip grow/shrink, default: false. */
	flexible?: boolean;

	/** CSSProperty overrides */
	style?: CSSProperties;

	/** set true if you do not want mouse events. */
	interactive?: boolean;

}>;




export const Chip = ({
	color = "primary",
	flexible,
	style,
	children,
	interactive = true,
}: ChipProps) => {

	const classes = () => [
		`chip-wrapper`,
		// `text-lg`,
		// `font-regular`,
		// `text-color-primary`,
		color,
		flexible ? 'flexible' : null,
		interactive ? null : 'interactionless',
	].filter(v => v).join(" ");

	const styles = ():CSSProperties => style || {};
	
	return (
		<div className={classes()}>
			<div className="chip" style={styles()}>
				{children}
			</div>
		</div>
	);
};
